<template>
  <div class="bg-white shadow">
    <div class="max-w-screen-xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
      <div class="xl:grid xl:grid-cols-3 xl:gap-8">
        <div class="grid grid-cols-2 gap-8 xl:col-span-2">
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4
                class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase"
              >Sources</h4>
              <ul class="mt-4">
                <li>
                  <a
                    href="https://remoteok.io/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >RemoteOK</a>
                </li>
                <li class="mt-4">
                  <a
                    href="https://remotive.io/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >Remotive</a>
                </li>
                <li class="mt-4">
                  <a
                    href="https://findwork.dev/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >Findwork</a>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0">
              <h4
                class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase"
              >Links</h4>
              <ul class="mt-4">
                <li>
                  <v-link
                    href="/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >Jobs</v-link>
                </li>
                <li class="mt-4">
                  <v-link
                    href="/new-job"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >New Job</v-link>
                </li>
                <li class="mt-4">
                  <v-link
                    href="/tools"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >Tools</v-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="md:grid md:grid-cols-2 md:gap-8">
            <div>
              <h4
                class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase"
              >Friends</h4>
              <ul class="mt-4">
                <li class="mt-4">
                  <a
                    href="https://www.reactmilkshake.com/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >React Milkshake</a>
                </li>
                <li class="mt-4">
                  <a
                    href="https://codestash.co/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >CodeStash</a>
                </li>
                <li class="mt-4">
                  <a
                    href="https://www.makermove.com/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >MakerMove</a>
                </li>
              </ul>
            </div>
            <div class="mt-12 md:mt-0">
              <h4
                class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase"
              >Friends</h4>
              <ul class="mt-4">
                <li class="mt-4">
                  <a
                    href="https://serverless.page/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >Serverless SaaS</a>
                </li>
                <li class="mt-4">
                  <a
                    href="https://www.raterfox.com/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >RaterFox</a>
                </li>
                <li class="mt-4">
                  <a
                    href="https://www.flowreads.com/"
                    class="text-base leading-6 text-gray-500 hover:text-gray-900"
                  >FlowReads</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="mt-8 xl:mt-0">
          <h4
            class="text-sm leading-5 font-semibold tracking-wider text-gray-400 uppercase"
          >Subscribe to our newsletter</h4>
          <p
            class="mt-4 text-gray-500 text-base leading-6"
          >Highlighted remote jobs in your inbox. very, very occasionally.</p>
          <form
            action="https://remoterocket.us18.list-manage.com/subscribe/post?u=2f5cd4a1d94eb9e83474f8f78&amp;id=3eadf85f11"
            method="POST"
            novalidate
            class="mt-4 sm:flex sm:max-w-md"
          >
            <input
              type="email"
              name="EMAIL"
              id="MERGE0"
              aria-label="Email"
              class="appearance-none w-full px-5 py-3 border border-gray-300 text-base leading-6 rounded-md text-gray-900 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:border-blue-300 focus:shadow-outline transition duration-150 ease-in-out"
              placeholder="Enter your email"
            />
            <div class="mt-3 rounded-md shadow sm:mt-0 sm:ml-3 sm:flex-shrink-0">
              <button
                id="mc-embedded-subscribe"
                type="submit"
                class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out"
              >Subscribe</button>
            </div>
            <div style="position: absolute; left: -5000px;" aria-hidden="true">
              <input type="text" name="b_2f5cd4a1d94eb9e83474f8f78_3eadf85f11" tabindex="-1" value />
            </div>
          </form>
        </div>
      </div>
      <div class="mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between">
        <div class="flex md:order-2">
          <a href="https://twitter.com/jakeprins_nl" class="ml-6 text-gray-400 hover:text-gray-500">
            <span class="sr-only">Twitter</span>
            <svg class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
              />
            </svg>
          </a>
        </div>
        <p
          class="mt-8 text-base leading-6 text-gray-400 md:mt-0 md:order-1"
        >&copy; 2020 RemoteRocket</p>
      </div>
    </div>
  </div>
</template>

<script>
import VLink from "./Link.vue";
export default {
  components: {
    VLink
  }
};
</script>

<style scoped>
ul,
li {
  list-style: none;
  padding: 0;
  margin-left: 0;
}
</style>
